export default {
  namespaced: true,
  actions: {
    test() {
    },
    fetchImage() {

    }
  }
}